export const GENDER_OPTIONS = ['male', 'female', 'other'] as const

export const PASSWORD_MIN_LENGTH = 8

export type Gender = (typeof GENDER_OPTIONS)[number]
